require('./dateInput.scss')

import React from 'react';
import PropTypes from 'prop-types';
import { OKInput } from 'commonsComponents/OKInput';

const { FormattedText } = require('core/i18n').i18n;

class DateInput extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            day: "",
            month: "",
            year: ""
        }
    }

    componentDidMount(){
        this.dayInput.el.addEventListener('keyup', this.onKeyPressDay)
        this.monthInput.el.addEventListener('keyup', this.onKeyPressMonth)
        this.yearInput.el.addEventListener('keyup', this.onKeyPressYear)
    }

    componentWillUnmount(){
        this.dayInput.el.removeEventListener('keyup', this.onKeyPressDay)
        this.monthInput.el.removeEventListener('keyup', this.onKeyPressMonth)
        this.yearInput.el.removeEventListener('keyup', this.onKeyPressYear)
    }

    onKeyPressDay = (event) => {
        const regex = /Digit(\d)$/i
        if (this.state.day.length == 2 && regex.test(event.code)){
            this.monthInput.el.focus()
            this.handleOnChange(event.key, 'month', 2)
        }
    }

    onKeyPressMonth = (event) => {
        if (event.code == 'Backspace' && this.state.month.length == 0) {
            this.dayInput.el.focus()
        }

        const regex = /Digit(\d)$/
        if (this.state.month.length == 2 && regex.test(event.code)){
            this.yearInput.el.focus()
            this.handleOnChange(event.key, 'year', 2)
        }
    }

    onKeyPressYear = (event) => {
        if (event.key == 'Backspace' && this.state.year.length == 0) {
            this.monthInput.el.focus()
        }
    }

    handleOnChange = (value, part, maxLength) => {
        const { 
            onDayChange,
            onMonthChange,
            onYearChange
        } = this.props
        const text = value || ""

        if (text.length <= maxLength && !Number.isNaN(Number(text))) {
            this.setState({[part]: value})

            switch (part) {
                case 'day': {
                    onDayChange(value)
                    text.length == maxLength && this.monthInput.el.focus()
                    break
                }
                case 'month': {
                    onMonthChange(value)
                    text.length == maxLength && this.yearInput.el.focus()
                    break
                }
                case 'year': {
                    onYearChange(value)
                    break
                }
                default:
                    return
            }
        }
    }

    render() {
        return (
            <div className="date-input">
                <div  className="date-input__label">
                    <FormattedText value="aggregatorAddEntity-formDateLabel"/>
                </div>
                <div className="date-input__value">
                    <OKInput
                        autocomplete="off"
                        name="day"
                        placeholder="DD"
                        min={1}
                        max={31}
                        value={this.state.day}
                        ref={ref => this.dayInput = ref}
                        id={"day"}
                        onChange={event => this.handleOnChange(event.target.value, 'day', 2)}
                    />
                    <OKInput
                        autocomplete="off"
                        name="month"
                        placeholder="MM"
                        min={1} 
                        max={12}
                        value={this.state.month}
                        ref={ref => this.monthInput = ref}
                        id={"month"}
                        onChange={event => this.handleOnChange(event.target.value, 'month', 2)}
                    />
                    <OKInput
                        autocomplete="off"
                        name="year"
                        placeholder="YYYY"
                        value={this.state.year}
                        ref={ref => this.yearInput = ref}
                        id={"year"}
                        onChange={event => this.handleOnChange(event.target.value, 'year', 4)}
                    />
                </div>
            </div>
        );
    }
}

DateInput.propTypes = {
    onDayChange: PropTypes.func,
    onMonthChange: PropTypes.func,
    onYearChange: PropTypes.func
}

export { DateInput }